import * as apiDelete from 'api/accessoryCategory/DeleteAccessoryCategoryIdV1';
import * as apiRestore from 'api/accessoryCategory/PostAccessoryCategoryRestoreV1';
import * as apiPostSearch from 'api/accessoryCategory/PostAccessoryCategorySearchV1';

export default class AccessoryCategory {
	public id: string = '';
	public name: string = '';
	public parentName: string | null = '';

	public constructor(input?: apiPostSearch.ResponseAccessoryCategory) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public async callApiDelete(): Promise<void> {
		await apiDelete.callApi(this.id);
	}

	public async callApiRestore(): Promise<void> {
		await apiRestore.callApi(this.id);
	}

	private mapFromApi(input: apiPostSearch.ResponseAccessoryCategory) {
		this.id = input.id;
		this.name = input.name;
		this.parentName = input.parentName;
	}
}
